import {
  genericGetSingle,
  genericGetAll,
  genericUpdateSingle,
  genericDeleteSingle,
} from "../helpers/apiCall";
import { Error } from "../types";
import { iOrder } from "../models";
import { parseJSONData } from "../helpers/json";

/**
 * Get all iOrders
 * @param params URLSearchParams
 * @returns Promise<{ orders: iOrder[] }>
 */
function getAll(params: URLSearchParams = null): Promise<{ orders: iOrder[] }> {
  return genericGetAll("i_orders", params);
}

/**
 * Get a single iOrder
 * @param id number | string
 * @returns Promise<{ order: iOrder }>
 */
function getSingle(id: number | string): Promise<{ order: iOrder }> {
  return genericGetSingle("i_orders", id).then((response) => {
    if (response?.order?.data) {
      response.order.loadedData = parseJSONData(response.order.data);
    }
    return response;
  });
}

/**
 * Update a single iOrder
 * @param id number | string
 * @param order { [key: string]: string | number | boolean | Date | undefined}
 * @returns Promise<{ order: iOrder } | Error>
 */
function updateSingle(
  id: number | string,
  order: { [key: string]: string | number | boolean | Date | undefined },
): Promise<{ order: iOrder } | Error> {
  return genericUpdateSingle("i_orders", id, order).then((response) => {
    if (response?.order?.data) {
      response.order.loadedData = parseJSONData(response.order.data);
    }
    return response;
  });
}

/**
 * Delete a single iOrder
 * @param id number | string
 * @returns Promise<{ deleted: boolean } | { error: string }>
 */
function deleteSingle(
  id: number | string,
): Promise<{ deleted: boolean } | { error: string }> {
  return genericDeleteSingle("i_orders", id);
}

/**
 * Gets the count of iOrders
 * @param params URLSearchParams
 * @returns Promise<{ count: number }>
 */
function getCount(params: URLSearchParams = null): Promise<{ count: number }> {
  params.append("countOnly", "true");
  return genericGetAll("i_orders", params);
}

export const iOrderService = {
  getAll,
  getSingle,
  updateSingle,
  deleteSingle,
  getCount,
};
